import { resetPassword } from "@/lib/api/auth-actions";
import { philosopher } from "@/lib/fonts";
import { zodResolver } from "@hookform/resolvers/zod";
import { forgotPasswordResetPasswordInputSchema } from "muminsmart-utils";
import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import z from "zod";
import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormControl,
  Form,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { routes } from "@/lib/constants";
import { useNavigate } from "react-router-dom";

interface ForgotPasswordResetPasswordProps {
  resetPasswordToken: string;
}

const ForgotPasswordResetPassword: React.FC<
  ForgotPasswordResetPasswordProps
> = ({ resetPasswordToken }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const form = useForm<z.infer<typeof forgotPasswordResetPasswordInputSchema>>({
    resolver: zodResolver(forgotPasswordResetPasswordInputSchema),
    defaultValues: {
      newPassword: "",
      resetPasswordToken,
    },
  });

  const onSubmit = async (
    values: z.infer<typeof forgotPasswordResetPasswordInputSchema>,
  ) => {
    setLoading(true);
    resetPassword(values.newPassword, values.resetPasswordToken)
      .then((res) => {
        if (res.success) {
          toast.success(res.message);
          navigate(routes.auth.login);
        } else toast.error(res.message);
      })
      .catch((error) => {
        toast.error(
          error.message || "Failed to reset password. Please try again.",
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="px-5">
      <h1
        className={`text-center text-secondary text-3xl font-semibold ${philosopher.className} mb-3`}
      >
        <span>Reset </span>
        <span className="text-primary">Password</span>
      </h1>
      <p className="text-[#6f6f6f] text-center text-sm mt-2 mb-10">
        Enter your new password below to reset your account password.
      </p>

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-5">
          <FormField
            control={form.control}
            name="newPassword"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="font-medium">New Password</FormLabel>
                <FormControl>
                  <Input
                    type="password"
                    placeholder="***********"
                    className="rounded-full p-5 bg-white"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button
            type="submit"
            className="w-full rounded-full bg-primary py-4 text-lg"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Reset Password"}
          </Button>
        </form>
      </Form>
    </div>
  );
};

export default ForgotPasswordResetPassword;
